import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { BuildingGenerationIssue } from "building-types/settings/buildingGenerationIssue";
import { BuildingGenerationIssueType } from "building-types/settings/buildingGenerationIssue";
import type { MaxBSPDepthErrorHandler } from "geom/bspTypes";

export function getMaxDepthErrorHandle(
  issues: BuildingGenerationIssue[],
  handle: DocEntityHandle,
): MaxBSPDepthErrorHandler {
  return () => {
    issues.push({
      type: BuildingGenerationIssueType.MAX_BSP_DEPTH_EXCEEDED,
      handle,
    });
  };
}
